/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.v1.CatalogResourceChirpFrontendService
 */
import * as References from './CatalogResourceChirpFrontendService';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.v1.CatalogResourceChirpFrontendService#getCatalogResources
 */
export const GET_CATALOG_RESOURCES_QUERY_FIELD_NAME =
  'com_hubspot_academy_catalog_rpc_v1_CatalogResourceChirpFrontendService_getCatalogResources';
export const GET_CATALOG_RESOURCES_QUERY: RegisteredQuery<
  'result',
  References.GetCatalogResourcesRequestType,
  References.GetCatalogResourcesResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_CATALOG_RESOURCES_QUERY_FIELD_NAME,
  args: ['requestedResources'],
  fetcher(
    request: References.GetCatalogResourcesRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetCatalogResourcesResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getCatalogResourcesRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
